// @flow

import { type IncomingPayment } from './types';

export function getCustomerEmail(incomingPayment: IncomingPayment): ?string {
  return incomingPayment['email'];
}
